import { useEffect, useState } from 'react';
import { trackEvent } from '../../lib/analytics';

const StickyCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleCtaClick = () => {
    trackEvent('cta_clicked', { cta_label: 'programme-sticky', page: 'prepa-post-bac' });
  };

  return (
    <div className={`ppb-sticky ${show ? 'is-visible' : ''}`}>
      <div className="ppb-sticky-inner">
        <div className="ppb-sticky-text">
          <strong>Prépa Post-Bac · GS Sanaa</strong>
          <span>Programme + conseiller orientation</span>
        </div>
        <a href="#form" onClick={handleCtaClick} className="btn btn-primary btn-sm">
          Recevoir
        </a>
      </div>
    </div>
  );
};

export default StickyCta;
